/**
 * IMPORTS
 */

import { videosTutoriasRepository } from "@/repositories/videos-tutorias";

const handleGetVideoTutorial = async (accessToken: string) => {
  try {
    const data = await videosTutoriasRepository.getVideoTutorial(accessToken);

    return data;
  } catch (error: unknown) {
    console.log("ERROR EM BUSCAR VIDEO TUTORIAL: ", error);

    throw error;
  }
};

/**
 * EXPORTS
 */
export { handleGetVideoTutorial };
